import React from 'react'
import Link from 'gatsby-link'

import styles from './RightBox.module.css'

class RightBox extends React.Component {
  render() {
    return (
      <div className={this.props.small ? styles.small_screen_drop : styles.box}>
        <Link to="Fact-Box">
          <p>Fact-Box</p>
        </Link>
        <Link to="Planungstool">
          <p>
            {this.props.isHomepage
              ? 'Planungstool für Gemeinden'
              : 'Planungstool Kinderbetreuung'}
          </p>
        </Link>
        <p>Links</p>
        <ul>
          <li>
            <a href="http://www.tagesmuetter.or.at/index.php/tagesmutter-finden.html">
              Tageseltern
            </a>
          </li>
          <li>
            <a href="https://www.burgenland.at/themen/bildung/kinderbildung-und-betreuung/ ">
              Land Burgenland Kinderbetreuung
            </a>
          </li>
        </ul>
        <Link to="Kontakt">
          <p>Kontakte</p>
        </Link>
      </div>
    )
  }
}

export default RightBox



// WEBPACK FOOTER //
// ./src/layouts/RightBox.js